import React, { useEffect, useState } from "react";

import "./login.scss";
import { toast } from "react-toastify";
import LoginForm from "./Form/LoginForm";
import { useDispatch } from "react-redux";
import { actions } from "../../redux/actions";
import { useLocation } from "react-router-dom";
import AuthService from "../../services/AuthService";

export default function Login(props) {
  const dispatch = useDispatch();
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);

  const location = useLocation();
  const data = location && location.state && location.state.params;

  let initialValues = {
    username: "",
    password: "",
    user_logged_storage: false,
  };

  useEffect(() => {
    localStorage.setItem("user_logged_storage", false);
  }, []);

  const send = (values) => {
    console.log(values);
    setLoading(true);
    let { username, password, user_logged_storage } = values;

    AuthService.login(username, password)
      .then((response) => {
        let message =
          response && response.response && response.response.data
            ? response.response.data
            : "";
        if (message !== "") {
          if (
            response &&
            response.response &&
            response.response.data &&
            response.response.data.message
          ) {
            setError(response.message);
          }
          return false;
        }

        if (user_logged_storage) {
          localStorage.setItem("user_logged_storage", user_logged_storage);
        }

        setLoading(false);
        dispatch(actions.setAuthentication(response));
      })
      .catch((error) => {
        if (error && error.message) {
          console.log(error);
          toast.error(error.message);
          setError(error.message);
        } else {
          toast.error("Erro ao logar. Verifique seu usuario e senha");
        }

        setLoading(false);
      });
  };

  return (
    <LoginForm
      initialValues={initialValues}
      send={send}
      error={error}
      loading={loading}
      success={data}
    />
  );
}
